import { trainingVersionRepository } from "../../../providers/repositories/trainingVersionRepository";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const deleteTrainingVersionUseCase = {
  async exec(id: string | number): Promise<boolean> {
    try {
      await trainingVersionRepository.delete(id);
      toast.success(t("action.deleteSuccess"));
      return true;
    } catch (error) {
      toast.error(t("action.deleteError"));
      Logger.error("deleteTrainingVersionUseCase", error);
    }
    return false;
  },
};
